<template>
  <div class="about_us">
    <div class="top">
      <div class="top__large">关于我们</div>
      <div class="top__small">ABOUT US</div>
    </div>
    <div class="content">
      <div class="title" id="profile">粤桥工科简介</div>
      <div class="sub-title">Company Profile</div>
      <div class="image">
        <img src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/about_company.png" width="100%" height="100%" />
      </div>

      <div class="title" id="introduce">团队介绍</div>
      <div class="sub-title">Team Introduce</div>
      <div class="image">
        <img src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/about_team1.png" width="100%" alt="" style="margin-bottom: 50px;">
        <!-- <img src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/about_team2.png" width="100%" alt=""> -->
      </div>

      <div class="title" id="progress">发展历程</div>
      <div class="sub-title">Development Progress</div>
      <div class="image">
        <img src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/about_progress.png" width="100%" height="100%" />
      </div>

      <div class="title" id="enterprise">合作企业</div>
      <div class="sub-title">Cooperative Enterprise</div>
      <div class="image">
        <img src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/about_enterprise.png" width="100%" height="100%" />
      </div>

      <div class="title" id="honors">荣誉成果</div>
      <div class="sub-title">Honors and Achievements</div>
      <div class="image">
        <img src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/about_honor1.png" width="100%" height="100%"/>
        <!-- <img src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/about_honor2.png" width="100%" height="100%" style="margin-top: 40px;" /> -->
      </div>

      <div class="title" id="contact">联系我们</div>
      <div class="sub-title">Contact Us</div>
      <div class="image">
        <img src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/map.png"/>
        <div class="contact">
          <div><Icon type="md-pin" color="red" style="margin-right: 20px;"/><b>地址: </b><span style="display: inline-block;">广州市天河区长福路205号C408单元</span><span style="display:block;margin-left: 96px;">广州市天河区五山路381号</span></div>
          <div><img src="../../assets/images/微信.png" alt="" style="display:inline-block;vertical-align: middle;margin-right:20px;width:20px;"><b>微信: </b><img src="https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/wechatQRcode2.jpg" alt="" style="width:150px;display:inline-block;margin-left:10px;vertical-align: top;"><span>(陈小姐)</span></div>
          <div><Icon type="md-mail" color="orange" style="margin-right: 20px;"/><b style="margin-right:10px">邮箱: </b>gzyqgc@163.com</div>
        </div>
      </div>
      <Anchor show-ink>
        <AnchorLink href="#profile" title="粤桥工科简介" />
        <AnchorLink href="#introduce" title="团队介绍" />
        <AnchorLink href="#progress" title="发展历程" />
        <AnchorLink href="#enterprise" title="合作企业" />
        <AnchorLink href="#honors" title="荣誉成果" />
        <AnchorLink href="#contact" title="联系我们" />
      </Anchor>
    </div>
  </div>
</template>
<script>
export default {
  name: 'about_us',
  data() {
    return {
    }
  },
  created() {
    this.$emit('changeProduce','about_us')
  },
  mounted () {
    if (this.$route.params.scroll) {
      const value = this.$route.params.scroll
      const srcollTab = document.getElementById(value)
      if (srcollTab) {
        srcollTab.scrollIntoView()
      }
    }
  }
}
</script>
<style lang="less" scoped>
.about_us {
  .top {
    width: 100%;
    height: 280px;
    background: url('https://yueq-website-1300597373.cos.ap-guangzhou.myqcloud.com/about_banner.png') center center no-repeat;
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    font-weight: bold;
    color: #fff;
    padding-left: 210px;
    &__large {
      font-size: 40px;
      line-height: 1.5em;
    }
    &__small {
      font-size: 28px;
      line-height: 1.2em;
      word-spacing: 15px;
    }
  }
  .content {
    width: 80%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-bottom: 64px;
    .title {
      margin: 48px 0 0;
      position: relative;
      font-size: 30px;
      line-height: 1.5em;
      font-weight: bold;
      color: #000;
    }
    .title::after {
      content: "";
      position: absolute;
      bottom: -8px;
      left: 50%;
      transform: translateX(-50%);
      width: 50px;
      height: 8px;
      background-color: #FAAD14;
    }
    .sub-title {
      margin: 10px 0 32px;
      font-size: 18px;
      line-height: 1.5em;
      color: #6D7278;
    }
    .image {
      margin-bottom: 32px;
      width: 80%;
      // height: 450px;
      img{
        display: block;
        margin: 0 auto;
        width: 100%;
      }
      .contact{
        width: 90%;
        margin: 20px auto 0;

        div{
          display: block;
          width: 100%;
          font-size: 18px;
          line-height: 2em;
          margin: 10px 0;
          span{
            margin: 0 20px 0 10px;
          }
        }
      }
    }

    .teamBox{
      display: block;
      width: 100%;
      
      img{
        display: block;
        width: 100%;
      }
    }
  }
}
/deep/ .ivu-anchor{
  position: fixed;
  right: 10px;
  top: 50%;
}
</style>
